<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>

    <!-- Search Section -->
    <section style="width: 100%;">
        <form (ngSubmit)="search()">
            <mat-form-field style="width: 100%;">
                <mat-label>Cerca...</mat-label>
                <input matInput [(ngModel)]="searchFilter">
                <button matSuffix matIconButton aria-label="search">
                    <mat-icon>search</mat-icon>
                </button>
            </mat-form-field>
        </form>
    </section>

    <!-- Chip Section -->
    <section>
        <mat-chip-set>
            @for (element of datasourceSelected; track element.displayId) {
            <mat-chip-row (removed)="onRemove(element)" (click)="onRemove(element)">
                {{element.displayName}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            }
        </mat-chip-set>
    </section>

    <!-- List Section -->
    <section>
        <div style="display: flex; flex-direction: column;">
            @for (element of datasource; track element.displayId) {
            <mat-checkbox [checked]="element.selected" (change)="onClick(element)" inViewport
                (inViewportAction)="inViewportAction($event, element)">
                {{element.displayName}}
            </mat-checkbox>
            }
        </div>
    </section>


</mat-dialog-content>
<mat-dialog-actions>
    <button matButton (click)="onClose()">
        <mat-icon fontIcon="backspace"></mat-icon>
        Discard
    </button>
    <button matButton [mat-dialog-close]="datasourceSelected" cdkFocusInitial>
        <mat-icon fontIcon="check"></mat-icon>
        Apply
    </button>
</mat-dialog-actions>